import React from 'react';
import ChartDateRange from './ChartDateRange';
import ChartDateGrain from './ChartDateGrain';
import {connect} from 'react-redux';
import {
  selectDateRangeByCardId,
  selectDateRangeFilterByCardId,
  selectDateGrainByCardId,
} from 'state/cardFilter/cardFilterSelectors';
import {selectIsSuperTable} from 'state/cardDetail/cardDetailSelectors';
import {
  updateDateRange,
  updateDateGrain,
} from 'state/cardFilter/cardFilterActions';
import {selectIsCardSettingEnabled} from 'state/cardSetting/cardSettingSelectors';
import {CARD_SETTINGS} from 'app/CardConstants';
import styles from './ChartDate.css?module';

class ChartDate extends React.Component {
  handleRangeChange = dateRangeFilter => {
    const {range} = this.props;
    this.props.updateDateRange(this.props.cardId, {
      ...range,
      dateRangeFilter,
    });
  };

  handleGrainChange = grain => {
    this.props.updateDateGrain(this.props.cardId, grain);
  };

  render() {
    const {
      grain,
      isFilterEnabled,
      dateRangeFilter,
      isSuperTable,
      range,
    } = this.props;
    const isEmpty = !range && !grain;

    if (!isFilterEnabled || isEmpty || isSuperTable) return null;

    return (
      <div className={styles.chartDate}>
        {range ? (
          <ChartDateRange
            column={range.columnName}
            dateRangeFilter={dateRangeFilter}
            onRangeChange={this.handleRangeChange}
          />
        ) : null}
        {grain ? (
          <ChartDateGrain
            grain={grain}
            onGrainChange={this.handleGrainChange}
          />
        ) : null}
      </div>
    );
  }
}

export default connect(
  (state, {cardId}) => ({
    range: selectDateRangeByCardId(state, cardId),
    dateRangeFilter: selectDateRangeFilterByCardId(state, cardId),
    grain: selectDateGrainByCardId(state, cardId),
    isFilterEnabled: selectIsCardSettingEnabled(state, CARD_SETTINGS.FILTER),
    isSuperTable: selectIsSuperTable(state, cardId),
  }),
  {
    updateDateRange,
    updateDateGrain,
  }
)(ChartDate);
